import type { QuantityUnitType } from '@acceligentllc/shared/enums/quantityUnit';

export function displayValue(value: Nullable<string>, unit: Nullable<QuantityUnitType>) {
	return value ? `${value} ${unit ?? ''}` : 'N/A';
}
